import { render } from "./MarkdownPreview.vue?vue&type=template&id=2b9e67ce&scoped=true"
import script from "./MarkdownPreview.vue?vue&type=script&lang=js"
export * from "./MarkdownPreview.vue?vue&type=script&lang=js"

import "./MarkdownPreview.vue?vue&type=style&index=0&id=2b9e67ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9e67ce"]])

export default __exports__